export const findFocusableElements = (container: HTMLElement) => {
  const focusable = container.querySelectorAll<HTMLElement>(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  );

  const visible = Array.from(focusable).filter((el) => window.getComputedStyle(el).display !== 'none');

  if (!focusable.length) return { allFocusable: null, firstFocusable: null, lastFocusable: null };

  return { allFocusable: visible, firstFocusable: visible[0], lastFocusable: visible[focusable.length - 1] };
};
